import React, { Component } from 'react';
import { Card, CardBody, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import Api from '../../config/Api';
import Notif from '../../components/Notification/Notif';
import Clock from 'react-live-clock';
export default class Landing extends Component {
	state = {
		calon1P: 0,
		calon2P: 0,
		calon1T: 0,
		calon2T: 0,
		total: 0,
		tdesa: 0,
		tkecamatan: 0,
		ttps: 0,
	};
	realCount = async () => {
		await Api.get('berita/realcount').then((p) => {
			this.setState({
				calon1P: p.data.rows.calon1P,
				calon2P: p.data.rows.calon2P,
				calon1T: p.data.rows.calon1T,
				calon2T: p.data.rows.calon2T,
				total: p.data.rows.total,
				tdesa: p.data.rows.tdesa,
				tkecamatan: p.data.rows.tkecamatan,
				ttps: p.data.rows.ttps,
			});
		});
	};
	componentDidMount = () => {
		this.realCount();
		let bomWaktu = setInterval(() => {
			this.realCount();
		}, 10000);
		this.setState({
			bomWaktu: bomWaktu,
		});
	};
	componentWillUnmount = () => {
		clearInterval(this.state.bomWaktu);
	};
	underC = () => {
		Notif(
			'd',
			'😇',
			sessionStorage.getItem('namaP') ? sessionStorage.getItem('namaP') : 'Utatku',
			'Fitur masih dalam pembangunan. Mohon untuk bersabar menunggu ya :)'
		);
	};

	render() {
		let hore = <Clock format={'HH : mm : ss'} ticking={true} />;

		return (
			<>
				<section className="section pb-1 pt-4 bg-gradient-warning">
					<Container fluid>
						<Row className="row-grid align-items-center">
							<Col className="text-center" lg="12">
								<div className="px-3">
									<Link to="/masuk">
										<div>
											<div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
												<i className="fa fa-bar-chart text-primary" />
											</div>
										</div>
									</Link>
									<div className="pl-4">
										<h3 className="display-3 text-white p-0 m-0	">REALCOUNT</h3>
										<p className="text-white p-0 m-0">
											Hitung Cepat Pilkada Bolaang Mongondow Selatan Tahun 2020
										</p>
										<h6 className="display-4 text-white">
											{hore}
											<small> WITA</small>
										</h6>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
				<section className="section pt-1 bg-gradient-warning">
					<Container fluid>
						<Row className="align-items-center">
							<Col className="order-lg-1" md="3" xs={6}>
								<div
									className="position-relative text-center"
									style={{
										display: 'block',
										marginLeft: 'auto',
										marginRight: 'auto',
										padding: 0,
									}}
								>
									<img
										alt="..."
										className="img-center img-fluid"
										src={require('assets/pilkada/1.png')}
									/>
								</div>
							</Col>
							<Col className="order-lg-2" md="3" xs={6}>
								<div
									className="position-relative text-center"
									style={{
										display: 'block',
										marginLeft: 'auto',
										marginRight: 'auto',
										padding: 0,
									}}
								>
									<img
										alt="..."
										className="img-center img-fluid"
										src={require('assets/pilkada/2.png')}
									/>
								</div>
							</Col>
							<Col className="order-lg-1" lg="6" xs={12}>
								<Card className="shadow shadow-lg--hover">
									<CardBody
										style={{
											display: 'flex',
											flexDirection: 'row',
											margin: 0,
											padding: 0,
										}}
									>
										<Col lg="6" sm={6} xs={6} className="text-center order">
											<br />

											<p className="text-uppercase text-warning font-weight-bold cardLanding">
												<CountUp
													start={0}
													end={this.state.calon1P}
													duration={1}
													separator="."
													decimals={2}
													decimal=","
												></CountUp>
												<small>%</small>
											</p>
											<h5 className="text-black">{this.state.calon1T} Suara</h5>
										</Col>
										<Col lg="6" sm={6} xs={6} className="text-center">
											<br />

											<p className="text-uppercase text-warning font-weight-bold cardLanding">
												<CountUp
													start={0}
													end={this.state.calon2P}
													duration={1}
													separator="."
													decimals={2}
													decimal=","
												></CountUp>
												<small>%</small>
											</p>

											<h5 className="text-black">{this.state.calon2T} Suara</h5>
										</Col>
									</CardBody>
								</Card>
							</Col>
						</Row>

						<Row className="align-items-center">
							<Col className="order-lg-1" md="3" xs={6}>
								<h5 className="mt-4 mb-0 pb-0 text-white text-center">Total Suara</h5>
								<h1 className="text-uppercase text-center text-white font-weight-bold mb-3">
									<CountUp start={0} end={this.state.total} duration={3} separator="."></CountUp>
								</h1>
							</Col>
							<Col className="order-lg-2" md="3" xs={6}>
								<h5 className="mt-4 mb-0 pb-0 text-white text-center">Total TPS</h5>
								<h1 className="text-uppercase text-center text-white font-weight-bold mb-3">
									<CountUp start={0} end={this.state.ttps} duration={3} separator="."></CountUp>
								</h1>
							</Col>
							<Col className="order-lg-3" md="3" xs={6}>
								<h5 className="mt-4 mb-0 pb-0 text-white text-center">Total Desa</h5>
								<h1 className="text-uppercase text-center text-white font-weight-bold mb-3">
									<CountUp start={0} end={this.state.tdesa} duration={3} separator="."></CountUp>
								</h1>
							</Col>
							<Col className="order-lg-3" md="3" xs={6}>
								<h5 className="mt-4 mb-0 pb-0 text-white text-center">Total Kecamatan</h5>
								<h1 className="text-uppercase text-center text-white font-weight-bold mb-3">
									<CountUp start={0} end={this.state.tkecamatan} duration={3} separator="."></CountUp>
								</h1>
							</Col>
						</Row>
					</Container>
				</section>
			</>
		);
	}
}
